<template>
  <div>
    <b-collapse :open="true" aria-id="empresainfo-aria">
      <div
        class="flex items-center my-2"
        slot="trigger"
        aria-controls="empresainfo-aria"
      >
        <Icon-Document class="text-primary-600" size="8" />
        <p class="pl-4 font-display text-xl font-bold">Arquivos Empresa</p>
      </div>

      <b-tag type="is-warning" v-if="getEmpresa.type != 'normal'">{{
        getEmpresa.type
      }}</b-tag>

      
      <div class="py-1 flex items-center" v-if="getEmpresa.procuracao" >
     
        <div class="py-1 flex items-center" v-show="getEmpresa.procuracao">
          <span class="mr-1 font-bold">Venc. Procuração:</span>
          <span
            class="text-neutral-100 py-0 px-1 rounded"
            :class="
              getDateDifferenceTheme(
                getDateDifferenceFrom(getEmpresa.procuracao.data_vencimento)
              )
            "
            v-text="
              moment(getEmpresa.procuracao.data_vencimento).format('DD/MM/YYYY')
            "
          >
          </span>
          <a
            href="#"
            class="ml-4 bg-primary-600 rounded-full p-2"
            @click.prevent="openEditProcuracaoModal(getEmpresa.procuracao)"
          >
            <Icon-Edit class="text-neutral-100" size="3" />
          </a>
        </div>
      </div>

      <div class="py-1 flex items-center" v-else>
        <span class="pr-2 font-bold">Venc. Procuração:</span>
        <a
          href="#"
          class="ml-4 bg-primary-600 rounded-full p-2"
          @click.prevent="openEditProcuracaoModal(getEmpresa.procuracao)"
        >
          <Icon-Plus class="text-neutral-100" size="3" />
        </a>
      </div>
      <div class="py-1 flex items-center" v-if="getEmpresa.certificado" >
     
     <div class="py-1 flex items-center" v-show="getEmpresa.certificado">
       <span class="mr-1 font-bold">Venc. Certificado:</span>
       <span
         class="text-neutral-100 py-0 px-1 rounded"
         :class="
           getDateDifferenceTheme(
             getDateDifferenceFrom(getEmpresa.certificado.validade)
           )
         "
         v-text="
           moment(getEmpresa.certificado.validade).format('DD/MM/YYYY')
         "
       >
       </span>
       <a
         href="#"
         class="ml-4 bg-primary-600 rounded-full p-2"
         @click.prevent="openEditCertificadoModal(getEmpresa.certificado)"
       >
         <Icon-Edit class="text-neutral-100" size="3" />
       </a>
     </div>
   </div>

   <div class="py-1 flex items-center" v-else>
     <span class="pr-2 font-bold">Venc. Certificado:</span>
     <a
       href="#"
       class="ml-4 bg-primary-600 rounded-full p-2"
       @click.prevent="openEditCertificadoModal(getEmpresa.certificado)"
     >
       <Icon-Plus class="text-neutral-100" size="3" />
     </a>
   </div>
    </b-collapse>

    <b-modal
      :active.sync="EditProcuracaoModal"
      v-if="EditProcuracaoModal"
      width="500px"
    >
      <Edit-Procuracao
        :procuracao="procuracao"
        :empresaId="getEmpresa.id"
        @edit-procuracao="onEditProcuracao"
      />
    </b-modal>
    <b-modal
      :active.sync="EditCertificadoModal"
      v-if="EditCertificadoModal"
      width="500px"
    >
      <Edit-Certificado
        :certificado="certificado"
        :empresaId="getEmpresa.id"
        @edit-certificado="onEditCertificado"
      />
    </b-modal>
    <!-- <b-modal
      :active.sync="EditCertificadoModal"
      v-if="EditCertificadoModal"
      width="600px"
    >
      <Edit-Alvara-Sanitario
        :certificado="certificado"
        :empresa-id="getEmpresa.id"
        @edit-alvara="onEditCertificado"
      />
    </b-modal> -->

    <b-modal :active.sync="showRegimeHistoryModal">
      <RegimeTributarioHistory :company-id="getEmpresa.id" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatEnToBr } from "@/utils/momentHelpers";
import moment from "moment";
import EditProcuracao from "@/views/empresas/procuracao/Edit";
import EditCertificado from "@/views/empresas/certificado/Edit";

export default {
  name: "EmpresaShowArquivosInfos",
  components: {
    EditProcuracao,
    EditCertificado,
  },
  data() {
    return {
      showRegimeHistoryModal: false,
      copiado: false,
      EditProcuracaoModal: false,
      EditCertificadoModal: false,
  

      procuracao: {},
      certificado: {},
    };
  },
  computed: {
    ...mapGetters(["getEmpresa"]),
 
  },
  methods: {
    copyText(value) {
      this.$copyText(value);
      this.copiado = value;
      setTimeout(() => (this.copiado = false), 1500);
    },
    formatEnToBr,
    moment,
    ...mapActions(["setEmpresa"]),
    getDateDifferenceFrom(val) {
      const momentDate = moment(val);
      const now = moment();
      return momentDate.diff(now, "days");
    },
    getDateDifferenceTheme(val) {
      if (val < 0) return "bg-neutral-900";
      if (val < 30) return "bg-error-base";
      if (val < 60) return "bg-warning-base";
      return "bg-info-base";
    },
    openEditProcuracaoModal(procuracao) {
      this.procuracao = procuracao;
      this.EditProcuracaoModal = true;
    },
    openEditCertificadoModal(certificado) {
      this.certificado = certificado;
      this.EditCertificadoModal = true;
    },

    onEditProcuracao() {
      this.EditProcuracaoModal = false;
      this.$router.push({ name: "empresas.index" });
    },
  },
};
</script>
